module.exports = __webpack_public_path__ + "img/Icon_queries.b7979f98.svg";